import { isIE, isTouchDevice } from '../_utils/BrowserDetect';

export default class Cursor {


	// Constructor
	constructor() {

		if (isIE() || isTouchDevice()) {
			return;
		}

		this.element = document.createElement('div');
		this.element.className = 'cursor';
		this.element.setAttribute('aria-hidden', 'true');

		this.shape = document.createElement('div');
		this.shape.className = 'cursor--shape';
		this.shape.setAttribute('aria-hidden', 'true');
		this.element.appendChild(this.shape);

		this.text = document.createElement('div');
		this.text.className = 'cursor--text';
		this.text.setAttribute('aria-hidden', 'true');
		this.element.appendChild(this.text);

		this.hoverColorEnter = this.hoverColorEnter.bind(this);
		this.hoverColorLeave = this.hoverColorLeave.bind(this);
		this.hoverTextEnter = this.hoverTextEnter.bind(this);
		this.hoverTextLeave = this.hoverTextLeave.bind(this);
		this.mouseLeave = this.mouseLeave.bind(this);
		this.mouseMove = this.mouseMove.bind(this);
		this.updateDom = this.updateDom.bind(this);

		this.hoversColor = [];
		this.hoversText = [];
		this.resetCursor();
	}


	// Public Methods
	destroy() {
		if (this.element === undefined) {
			return;
		}
		this.disable();
		delete this.animId;
		delete this.cursorColor;
		delete this.cursorHover;
		delete this.cursorText;
		delete this.cursorTextHideOnLinkHover;
		delete this.cursorVisible;
		delete this.cursorX;
		delete this.cursorY;
		delete this.element;
		delete this.hoversColor;
		delete this.hoversText;
		delete this.shape;
		delete this.text;
	}
	enable() {
		if (this.element === undefined) {
			return;
		}
		if (this.element.parentNode !== null) {
			return;
		}
		this.resetCursor();
		document.body.classList.add('cursor-enabled');
		document.body.appendChild(this.element);
		document.addEventListener('mouseleave', this.mouseLeave);
		document.addEventListener('mousemove', this.mouseMove);
		this.animId = requestAnimationFrame(this.updateDom);
		this.updateHovers();
	}
	disable() {
		if (this.element === undefined) {
			return;
		}
		if (this.element.parentNode === null) {
			return;
		}
		document.body.classList.remove('cursor-enabled');
		this.element.parentNode.removeChild(this.element);
		document.removeEventListener('mouseleave', this.mouseLeave);
		document.removeEventListener('mousemove', this.mouseMove);
		cancelAnimationFrame(this.animId);
		this.removeAllHovers();
	}
	updateHovers() {
		if (this.element === undefined) {
			return;
		}

		this.removeAllHovers();

		let items, i, l;

		items = Array.prototype.slice.call(document.querySelectorAll('[data-cursor-color]'), 0);
		for (i=0, l=items.length; i<l; i++) {
			items[i].addEventListener('mouseover', this.hoverColorEnter);
			items[i].addEventListener('mouseleave', this.hoverColorLeave);
			this.hoversColor.push(items[i]);
		}

		items = Array.prototype.slice.call(document.querySelectorAll('[data-cursor-text]'), 0);
		for (i=0, l=items.length; i<l; i++) {
			items[i].addEventListener('mouseover', this.hoverTextEnter);
			items[i].addEventListener('mouseleave', this.hoverTextLeave);
			this.hoversText.push(items[i]);
		}
	}


	// Private Methods
	removeAllHovers() {
		let item;
		while (this.hoversColor.length > 0) {
			item = this.hoversColor.pop();
			item.removeEventListener('mouseover', this.hoverColorEnter);
			item.removeEventListener('mouseleave', this.hoverColorLeave);
		}
		while (this.hoversText.length > 0) {
			item = this.hoversText.pop();
			item.removeEventListener('mouseover', this.hoverTextEnter);
			item.removeEventListener('mouseleave', this.hoverTextLeave);

		}
	}
	resetCursor() {
		this.cursorColor = '';
		this.cursorHover = false;
		this.cursorText = '';
		this.cursorTextHideOnLinkHover = false;
		this.cursorVisible = true;
		this.cursorX = -100;
		this.cursorY = -100;
	}


	// Event Handlers
	hoverColorEnter(event) {
		this.cursorColor = event.currentTarget.getAttribute('data-cursor-color');
	}
	hoverColorLeave() {
		this.cursorColor = '';
	}
	hoverTextEnter(event) {
		event.stopPropagation()
		this.cursorText = event.currentTarget.getAttribute('data-cursor-text');
		this.cursorTextHideOnLinkHover = event.currentTarget.hasAttribute('data-cursor-text-hide-on-link-hover') || event.currentTarget.hasAttribute('data-cursor-disabled') ? true : false;
	}
	hoverTextLeave() {
		this.cursorText = '';
		this.cursorTextHideOnLinkHover = false;
	}
	mouseLeave() {
		this.cursorHover = false;
		this.cursorVisible = true;
	}
	mouseMove(event) {
		this.cursorHover = (event.target.tagName === 'A' || event.target.tagName === 'BUTTON');
		if (event.target.className === 'arrow-link') {
			this.cursorHover = 'A';
		}
		this.cursorVisible = false;
		this.clientX = event.clientX;
		this.clientY = event.clientY;
	}
	updateDom() {
		this.element.style.transform = `translate3d(${this.clientX}px, ${this.clientY}px, 0)`;

		this.element.setAttribute('data-color', this.cursorColor);

		if (this.cursorHover) {
			this.element.classList.add('hover');
		} else {
			this.element.classList.remove('hover');
		}

		if (this.cursorTextHideOnLinkHover && this.cursorHover) {
			this.element.classList.remove('has-text');
		} else if (this.cursorText !== '') {
			this.element.classList.add('has-text');
			this.text.innerHTML = this.cursorText;
		} else {
			this.element.classList.remove('has-text');
		}

		if (this.cursorVisible) {
			this.element.classList.add('hide');
		} else {
			this.element.classList.remove('hide');
		}

		this.animId = requestAnimationFrame(this.updateDom);
	}


}
